import { Link } from "react-router-dom";
import { ArrowLeft, BellRing } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "@/components/Reveal";

const UPCOMING = [
  "How the right flooring protects your pup's joints",
  "Understanding dog temperament in group play",
  "Why freshly cooked meals beat packaged food",
  "A day in the life of a boarding guest",
];

export default function Blogs() {
  return (
    <section data-testid="blogs-page" className="pt-32 pb-28 lg:pt-40">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <Reveal y={14}>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-bark">The blog</p>
          </Reveal>
          <h1 className="mt-6 font-display text-4xl font-medium leading-[1.08] tracking-tight text-ink sm:text-5xl lg:text-6xl">
            <span className="mask-line">
              <span style={{ animationDelay: "0.15s" }}>Good stories take a little</span>
            </span>
            <span className="mask-line">
              <span style={{ animationDelay: "0.28s" }}>
                <em className="font-editorial italic text-bark">fetching.</em>
              </span>
            </span>
          </h1>
          <Reveal delay={0.45}>
            <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">
              Training tips, nutrition notes and behind-the-scenes tales from the facility —
              arriving soon. Here's a peek at what's coming.
            </p>
          </Reveal>
          <Reveal delay={0.55}>
            <button
              type="button"
              data-testid="blogs-notify-button"
              onClick={() => toast.success("Noted! We'll let you know when the blog goes live.")}
              className="mt-9 inline-flex items-center gap-2 rounded-full bg-navy px-7 py-4 text-sm font-semibold text-cream transition-colors duration-200 hover:bg-ink"
            >
              <BellRing className="h-4 w-4" aria-hidden="true" />
              Notify me when it's live
            </button>
          </Reveal>
        </div>

        <div className="mt-20 grid gap-5 sm:grid-cols-2">
          {UPCOMING.map((title, i) => (
            <Reveal key={title} delay={i * 0.07}>
              <div
                data-testid={`blogs-upcoming-${i + 1}`}
                className="flex h-full flex-col rounded-3xl border border-dashed border-ink/15 bg-white/60 p-8"
              >
                <span className="w-fit rounded-full bg-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">
                  Coming soon
                </span>
                <h2 className="mt-5 flex-1 font-display text-xl font-medium leading-snug tracking-tight text-ink">
                  {title}
                </h2>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-16 text-center">
            <Link
              to="/"
              data-testid="blogs-back-home"
              className="group inline-flex items-center gap-2 text-sm font-semibold text-navy"
            >
              <ArrowLeft
                className="h-4 w-4 text-bark transition-transform duration-200 group-hover:-translate-x-1"
                aria-hidden="true"
              />
              Back to home
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
